import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const GET_EFFECTIVE_TEAM_SCHEDULING_SETTINGS_QUERY_KEY =
  'GET_EFFECTIVE_TEAM_SCHEDULING_SETTINGS';

export const useGetEffectiveTeamSchedulingSettings = (teamId: number) => {
  const { getEffectiveTeamSchedulingSettings } = useServicesContext();

  return useQuery({
    queryKey: [GET_EFFECTIVE_TEAM_SCHEDULING_SETTINGS_QUERY_KEY, teamId],
    queryFn: () => getEffectiveTeamSchedulingSettings(teamId),
    enabled: !!teamId,
  });
};
